import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface LaborExtraState {
  id: string;
  name: string;
  isActive: boolean;
  props: {
    [key: string]: any;
  };
}

const initialState: LaborExtraState = {
  id: '',
  name: '',
  isActive: false,
  props: { isModalVisible: false, refresh: false, searchTerm: '', skip: 1, take: 10, totalItems: 0 },
};

const laborExtraSlice = createSlice({
  name: 'laborExtra',
  initialState,
  reducers: {
    setLaborExtra: (state, action: PayloadAction<Partial<LaborExtraState>>) => {
      return { ...state, ...action.payload };
    },

    resetLaborExtra: (_state, action: PayloadAction<Partial<LaborExtraState['props']> | undefined>) => {
      return {
        ...initialState,
        props: { ...initialState.props, ...action.payload },
      };
    },

    updateField: (state: LaborExtraState, action: PayloadAction<{ field: any; value: any }>) => {
      const { field, value } = action.payload;
      (state as any)[field] = value;
    },

    updateProps: (state, action: PayloadAction<{ field: string; value: any }>) => {
      const { field, value } = action.payload;
      state.props = {
        ...state.props,
        [field]: value,
      };
    },
  },
});

export const { setLaborExtra, resetLaborExtra, updateField, updateProps } = laborExtraSlice.actions;

export default laborExtraSlice.reducer;
